// @flow
import React from "react";
import moment from "moment";

type ExpiresColorLabelPropsType = {
  expiryDate: moment,
  expiryMinutes: number,
  title?: boolean,
  exact?: boolean,
  extentDate?: string
};

const ExpiresColorLabel = (props: ExpiresColorLabelPropsType): React$Element<*> => {
  const expireDate = props.expiryDate;
  const expiryMinutes = props.expiryMinutes;
  if (expiryMinutes < 0) {
    return (
      <span className="red-label">
        {props.title ? "Expired On " : ""}
        {props.exact ? expireDate.format("DD/MMM/YYYY hh:mm A") : expireDate.format("DD/MMM/YYYY")}
      </span>
    );
  }
  else if (0 <= expiryMinutes && expiryMinutes < 7 * 60 * 24) {
    return (
      <span className="pink-label">
        {props.title ? "Expires In " : ""}
        {props.exact ? expireDate.fromNow(true) + " ( " + expireDate.format("DD/MMM/YYYY hh:mm A") + " )" : expireDate.fromNow(true)}
      </span>
    );
  }
  else if (7 * 60 * 24 <= expiryMinutes && expiryMinutes < 200 * 365 * 60 * 24) {
    return (
      <span className="green-label">
        {props.title ? "Expires In " : ""}
        {props.exact ? expireDate.fromNow(true) + " ( " + expireDate.format("DD/MMM/YYYY hh:mm A") + " )" : expireDate.fromNow(true)}
      </span>
    );
  }
  else {
    const extendMinute = props.extentDate && props.extentDate.diff(moment.utc().local(), "minutes");
    return (
      <span>
        <span className="dark-label">
          Perpetual
        </span>
        {!props.title && props.extentDate && extendMinute < 0 &&
          <span className="red-label left-margin-5">
            Maintenance Expired On
            {props.extentDate.format("DD/MMM/YYYY hh:mm A")}
          </span>
        }
        {!props.title && props.extentDate && extendMinute >= 0 &&
          <span className="green-label left-margin-5">
            Maintenance Expires In {props.extentDate.format("DD/MMM/YYYY hh:mm A")}
          </span>
        }
      </span>
    );
  }
};

export default ExpiresColorLabel;
